import React from 'react'
import clsx from 'clsx'

import useStyles from './styles'

const defaultClasses = {
  root: '',
  rootChecked: '',
  thumb: '',
  thumbChecked: ''
}

const Switch = ({
  checked = false,
  onChange = val => {},
  disabled = false,
  classes: extraClasses = defaultClasses
}) => {
  const classes = useStyles({ disabled })

  const handleClick = React.useCallback(() => {
    if (!disabled) {
      onChange && onChange(!checked)
    }
  }, [disabled, onChange, checked])

  return (
    <div
      onClick={handleClick}
      className={clsx(
        classes.root,
        extraClasses.root,
        checked && clsx(classes.rootChecked, extraClasses.rootChecked)
      )}
    >
      <div
        className={clsx(
          classes.thumb,
          extraClasses.thumb,
          checked && clsx(classes.thumbChecked, extraClasses.thumbChecked)
        )}
      />
    </div>
  )
}

export default Switch
